// Poppins + Open Sans (de app-brede huisstijl, zie index.css) staan altijd
// al geladen via public/index.html. De overige 4 merk-lettertypes die een
// Premium/tester-aanbieder kan kiezen (LinkBrandingSettings.js) worden hier
// pas dynamisch opgehaald, en enkel wanneer ze effectief gebruikt worden —
// zo betaalt niet elke bezoeker van elke boekingspagina voor lettertypes die
// die specifieke aanbieder niet eens gekozen heeft.
export const EXTRA_BRANDING_FONT_NAMES = ['Montserrat', 'Lato', 'Playfair Display', 'Merriweather'];

// Zelf gehost (public/fonts/fonts-extra.css): geen verbinding met Google.
const EXTRA_BRANDING_FONTS_HREF = '/fonts/fonts-extra.css';

export function ensureExtraBrandingFontsLoaded() {
    if (document.querySelector(`link[href="${EXTRA_BRANDING_FONTS_HREF}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = EXTRA_BRANDING_FONTS_HREF;
    document.head.appendChild(link);
}
